import React from "react";
import imageHome from "../../resources/SMC_2.jpg";
import { Image } from "react-bootstrap";
import MenuHeader from "../../components/menuHeader";

const About = () => {
  return (
    <>
      <MenuHeader current="About" />
      <div className="center-screen">
        <div class="container">
          <div class="row">
            <div class="col-12 col-xs-12 col-sm-12 col-lg-6">
              <div className="mx-auto text-center">
                <Image className="about-image" src={imageHome} />
              </div>
            </div>
            <div class="col about-text-container">
              <div>
                <div className="about-text metropolis-regular">
                  Sara Meneses Cuapio is a photographer and designer born and
                  raised in Tlaxcala, Mexico. From a family of Nahua descent,
                  her work centers on identity and memory within her lineage.
                  Her practice moves between documentary photography and staged
                  imagery, working across reality and metaphor. Through manual
                  processes, Sara activates the spectral, generating images that
                  evoke dreamlike experiences, ethical perspectives, and
                  memories. She conceives nature, darkness, the hidden, and the
                  intimate as spaces where the sacred and the visceral coexist. <br /><br />
                  Sara holds a degree in Craft Design with additional studies in
                  Art History and Social Anthropology. She is a graduate of the
                  Photography Production Seminar at Centro de la Imagen in
                  Mexico. In 2022, she received the Young Creators Grant from
                  Mexico’s National Fund for Culture and the Arts. She has been
                  nominated for Ones to Watch by the British Journal of
                  Photography, the Joop Swart Masterclass, from World Press
                  Photo and the Leica Oskar Barnack Award, where she was a
                  finalist in 2024. Her work has been exhibited at venues
                  including the Ernst Leitz Museum, BASE Milano with PhotoVogue,
                  and the Biarritz Film Festival, among others. Her practice has
                  been featured in various publications, including the journal
                  of Mexico's National Photographic Archive. She has also
                  collaborated with institutions such as the École des Arts
                  Décoratifs in Paris. Sara is currently a Paul Fusco Fellow in
                  the Documentary Practice Program at the International Center
                  of Photography.
                  <br />
                  <br /> Sara Meneses Cuapio © All Rights Reserved <br />
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
